import { useEffect, useState } from 'react'
import { useMediaQuery, useTheme } from '@mui/material'
import { useQueryClient } from 'react-query'
import { useParams } from 'react-router-dom'

import { ItemsList } from './items-list.component'
import { TableList } from './table-list.component'
import { ModalTitle } from './modal-title.component'
import { StepsConnectionsFilter } from './steps-connections-filter.component'
import { initialAccountStepsConnectionFilterValues, useAccountStepsConnections } from 'src/hooks'
import { IFilter } from 'src/components/filter/types/filter.types'
import { QUERY_KEYS } from 'src/constants'

import { sortToObject } from 'src/common/utils'

import { useStyles } from 'src/components/impacts-library/impacts-library-list/styles'

const defaultSort = 'connection.account_disconnected-asc'

const StepsConnectionsContent = () => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()
  const [filter, setFilter] = useState<IFilter>(initialAccountStepsConnectionFilterValues)
  const [sort, setSort] = useState(defaultSort)

  const { data: items } = useAccountStepsConnections({
    ...filter,
    ...sortToObject(sort),
  })

  const classes = useStyles()
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

  useEffect(() => {
    queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT_STEPS_CONNECTION, accountId])

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className={classes.upperWrapper}>
        <ModalTitle />
        <div>
          <StepsConnectionsFilter setFilter={setFilter} filter={filter} />
          {isTablet ? (
            <ItemsList items={items?.data || []} />
          ) : (
            <TableList sort={sort} setSort={setSort} items={items?.data || []} />
          )}
        </div>
      </div>
    </>
  )
}

export { StepsConnectionsContent }
